import { render, staticRenderFns } from "./InfrastructureCollisionsSettings.vue?vue&type=template&id=ab753e9c&"
import script from "./InfrastructureCollisionsSettings.vue?vue&type=script&lang=js&"
export * from "./InfrastructureCollisionsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports